<template>
  <div class="home">
    <h2>欢迎来到后台管理系统</h2>
    <div class="heading">更新日志</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>版本1.0.9</span>
        <span style="float: right; padding: 3px 0" type="text">2023-06-25</span>
      </div>
      <div class="text item">
        1.门诊日志筛选功能优化<br />
        2.皮肤科新增耗材使用情况<br />
        3.皮肤科耗材管理功能优化<br />
        4.科室新增手术清单功能<br />
        5.科室项目配置功能优化<br />
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>版本1.0.8</span>
        <span style="float: right; padding: 3px 0" type="text">2023-05-18</span>
      </div>
      <div class="text item">
        1.耗材管理功能优化<br />
        2.注射微整科显示数据统计<br />
        3.门诊日志显示功能优化<br />
        4.门诊日志导出功能优化<br />
        5.员工管理功能优化<br />
        6.皮肤科数据新增限制调整<br />
        7.皮肤科购买增加备注<br />
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>版本1.0.7</span>
        <span style="float: right; padding: 3px 0" type="text">2023-04-20</span>
      </div>
      <div class="text item">
        1.增加门诊日志表列表页面<br />
        2.皮肤科项目增加门诊选项<br />
        3.身份表增加门诊选项，皮肤科门诊，外科门诊，注射微整科门诊<br />
        4.皮肤科录入时在划扣项目后面增加仪器选择<br />
        5.用户增加多角色配置功能<br />
        6.登记表、消费表列表页默认显示查询当月数据<br />
        7.同一个账号同一时间只能登录一个<br />
        8.仪器使用记录、门诊日志，不符合导出条件的单元格标红<br />
        9.管理配置-美容皮肤科改名为美容皮肤科配置<br />
        10.管理配置增加仪器配置，仪器录入的字段内容为名称、规范名称、打印名称、院区、科室、设备<br />
        11.仪器记录表头为 日期、仪器名、姓名、仪器状况（默认都是好）、使用人、护士<br />
        12.使用人、护士、项目、仪器都允许的情况下才能打印<br />
        13.查询时姓名、手机号、卡号的BUG修复<br />
        14.项目、仪器、院区、耗材，增加禁用操作<br />
        15.皮肤科消费表列表页上，性别，年龄，信息来源，划扣卡号，产品备注主页面隐藏掉。医生，医助，护士，移动到备注后面<br />
        16.皮肤科消费表新增时历史记录无法翻页BUG修复<br />
        17.马、张、袁单独的情况下，显示及导出均给予一个明确的提示，比如绿色的底色<br />
        18.新增皮肤消费表里，已购买记录计算优化<br />
        19.皮肤科消费表增加修改价格功能<br />
        20.针对所有项目增加以下判断：<br />
        20.1、医生和医助不同时出现<br />
        20.2、护士和医助不能是同一个人<br />
        21.业绩表导出，加入“厂家”，放在“耗材规格”后<br />
        22.所有配置信息详细配置到具体院区具体科室<br />
      </div>
    </el-card>

  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {

  },
  data() {
    return {}
  },
  methods: {

  },
  created() {

  },
}
</script>
<style scoped>
.text {
  font-size: 16px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.heading {
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
}
.box-card {
  margin-bottom: 5px;
}
.home {
  padding: 10px;
  box-sizing: border-box;
}
</style>

